import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=1d71b0be&"
import script from "./goods-info.vue?vue&type=script&lang=js&"
export * from "./goods-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports